type OauthScopeProps = {
	id: string;
	name: string;
	description: string;
	required: boolean;
	key: string;
	usedByAddOns: string[];
};

class OauthScope {
	constructor(public _: OauthScopeProps) {}

	static fromJson(json: any): OauthScope {
		return new OauthScope({
			id: json.id,
			name: json.name,
			description: json.description,
			required: json.required,
			key: json.key,
			usedByAddOns: json.used_by_add_ons,
		});
	}

	toJson() {
		return {
			id: this._.id,
			name: this._.name,
			description: this._.description,
			required: this._.required,
			key: this._.key,
			used_by_add_ons: this._.usedByAddOns,
		};
	}
}

export { OauthScope };